import {mixins} from "../app/mixin";

mixins.push({
    el: '.homeLandingDigitalSolutions',
    data() {
        return {activeProduct: 0}
    }, methods: {
        setActiveProduct(productId) {
            if (productId !== this.activeProduct) {
                this.activeProduct = productId;
            }
        }, goToPage(path, openBlank) {
            if (openBlank) {
                window.open(path, '_blank');
            } else {
                location.href = path;
            }
        }
    }
});